export enum AuditAction {
  DOWNLOAD_DOCUMENT = "DOWNLOAD_DOCUMENT",
  VIEW_VERIFICATION = "VIEW_VERIFICATION",
  SUBMIT_VERIFICATION = "SUBMIT_VERIFICATION",
  APPROVE_VERIFICATION = "APPROVE_VERIFICATION",
  REJECT_VERIFICATION = "REJECT_VERIFICATION",
  CANCEL_VERIFICATION = "CANCEL_VERIFICATION",
  UPDATE_VERIFICATION = "UPDATE_VERIFICATION"
}

export enum BjjBelt {
  WHITE = "WHITE",
  BLUE = "BLUE",
  PURPLE = "PURPLE",
  BROWN = "BROWN",
  BLACK = "BLACK"
}

export enum BjjStyle {
  GI = "GI",
  NO_GI = "NO_GI"
}

export enum Continents {
  Africa = "Africa",
  Antarctica = "Antarctica",
  Asia = "Asia",
  Europe = "Europe",
  Oceania = "Oceania",
  North_America = "North_America",
  South_America = "South_America"
}

export enum EventFormat {
  FIGHT_CARD = "FIGHT_CARD",
  TOURNAMENT = "TOURNAMENT",
}

export enum EventInvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED"
}

export enum FightCardStatus {
  SCHEDULED = "SCHEDULED",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED"
}

export enum TournamentMatchStatus {
  SCHEDULED = "SCHEDULED",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
}

export enum FightOfferApplicationStatus {
  APPLIED = "APPLIED",
  SELECTED = "SELECTED",
  REJECTED = "REJECTED",
  WITHDRAWN = "WITHDRAWN"
}

export enum FightOfferResponseDeadlineType {
  ONE_DAY = "ONE_DAY",
  TWO_DAY = "TWO_DAY",
  THREE_DAY = "THREE_DAY",
  CUSTOM = "CUSTOM",
  NEVER = "NEVER"
}

export enum FightOfferStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  COUNTERED = "COUNTERED",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  WITHDRAWN = "WITHDRAWN",
  EXPIRED = "EXPIRED"
}

export enum FightOfferTravelCostCoverage {
  FULLY_COVERED = "FULLY_COVERED",
  NOT_COVERED = "NOT_COVERED",
  CUSTOM = "CUSTOM"
}

export enum FightOfferVisibility {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE"
}

export enum MartialArts {
  BOX = "BOX",
  MUAI_THAI = "MUAI_THAI",
  KICKBOX = "KICKBOX",
  MMA = "MMA",
  BARE_KNUCKLE = "BARE_KNUCKLE",
  BJJ_NO_GI = "BJJ_NO_GI",
  BJJ_GI = "BJJ_GI"
}

export enum MatchResult {
  WIN = "WIN",
  DRAW = "DRAW",
  LOSS = "LOSS"
}

export enum MatchResultType {
  KO = "KO",
  TKO = "TKO",
  SUB = "SUB",
  UD = "UD",
  SD = "SD",
  MD = "MD",
  DQ = "DQ",
  NC = "NC"
}

export enum OpenToFightCategories {
  Professional = "Professional",
  Amateur = "Amateur",
  Exhibition = "Exhibition"
}

export enum EventStatus {
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED"
}

export enum OrganizationRole {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  NO_ROLE = "NO_ROLE"
}

export enum ProfileReportCategory {
  FAKE_PROFILE = "FAKE_PROFILE",
  INAPPROPRIATE_CONTENT = "INAPPROPRIATE_CONTENT",
  HARASSMENT_OR_ABUSE = "HARASSMENT_OR_ABUSE",
  IMPERSONATION = "IMPERSONATION",
  OTHER = "OTHER"
}

export enum Role {
  FIGHTER = "FIGHTER",
  GYM_OWNER = "GYM_OWNER",
  ORG_OWNER = "ORG_OWNER",
  REFEREE = "REFEREE",
  VIEWER = "VIEWER"
}

export enum Sex {
  Male = "Male",
  Female = "Female"
}

export enum UserFeedbackType {
  BUG_REPORT = "BUG_REPORT",
  FEATURE_REQUEST = "FEATURE_REQUEST",
  GENERAL = "GENERAL"
}

export enum VerificationEntityType {
  FIGHTER = "FIGHTER",
  GYM = "GYM",
  ORGANISATION = "ORGANISATION"
}

export enum VerificationRequestType {
  VERIFICATION = "VERIFICATION",
  CLAIM = "CLAIM"
}

export enum VerificationStatus {
  PENDING = "PENDING",
  MORE_INFO_REQUIRED = "MORE_INFO_REQUIRED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
  REMOVED = "REMOVED",
  NOT_SUBMITTED = "NOT_SUBMITTED"
}

export enum WeighInUnit {
  percent = "percent",
  kg = "kg",
  g = "g",
  lbs = "lbs",
  oz = "oz"
}
